import { render, staticRenderFns } from "./Lives.vue?vue&type=template&id=48085561"
import script from "./Lives.vue?vue&type=script&lang=js"
export * from "./Lives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports